<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="KeHuList" data-title="跟进记录">
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white p-2.5 rounded-lg">
      <div class="flex gap-x-5">
        <el-segmented
          v-model="state.params.status"
          :props="{
            label: 'Text',
            value: 'Key',
          }"
          :options="[
            { Text: '全部' },
            {
              Key: 1,
              Text: '上门拜访',
            },
            {
              Key: 2,
              Text: '电话沟通',
            },
            {
              Key: 3,
              Text: '微信沟通',
            },
          ]"
          class="c-segmented"
          @change="onLoad()"
        />
        <el-date-picker
          v-model="state.params.date"
          type="date"
          placeholder="跟进日期"
        />
      </div>
      <div
        v-if="state.list_data?.length > 0"
        class="overflow-hidden flex flex-col"
      >
        <div class="overflow-y-auto flex flex-col gap-y-3 mt-3">
          <div
            class="bg-white p-4 flex flex-col gap-y-2 border-gray-100"
            :class="index != 0 ? 'border-t' : ''"
            v-for="(item, index) in state.list_data"
            :key="item"
          >
            <ul class="flex gap-x-5 mb-1">
              <strong>{{ item.rq }}</strong>
              <el-tag type="warning">{{ item.type_name }}</el-tag>
            </ul>
            <c_cell title="跟进内容" :value="item.gjnr" />
            <c_cell title="客户反馈" :value="item.khfk" />
            <div class="flex flex-wrap gap-x-5 gap-y-2">
              <el-image
                v-for="tp in item.tps"
                :key="tp"
                :src="tp"
                class="w-40 h-28 rounded-md"
              />
            </div>
            <div class="flex items-center text-gray-400 text-xs gap-x-2 mt-2">
              <text class="text-sm text-gray-600">
                {{ item?.add_admin_name }}
              </text>
              <text>{{ item?.add_department_name }}</text>
              <text class="ml-1">{{ item?.create_time }} 创建</text>
            </div>
          </div>
        </div>
        <c_page
          :total="state.totalCount"
          :pageIndex="state.params.page"
          :pageSize="state.params.limit"
          @onLoad="
            (page) => {
              state.params.page = page.pageIndex;
              state.params.limit = page.pageSize;
              onLoad();
            }
          "
        />
      </div>
      <div class="text-center" v-else>
        <el-image :src="require('@/assets/images/nodata.png')" />
      </div>
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="state.selectId ? '编辑联系人' : '新建联系人'"
    class="c-el-dialog"
    width="500"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
  >
    <c_info
      :id="state.selectId"
      :customer_id="props.customer_id"
      @close="
        (refresh) => {
          state.showInfo = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { onDeleteConfirm } from "@/utils/funcs";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    customer_id: Number,
  },
  components: {
    c_info,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.customer_id = props.customer_id;
      onLoad();
    });

    const onLoad = () => {
      state.list_data = [
        {
          id: 1,
          rq: "2026-04-18",
          type_name: "上门拜访",
          gjnr: "微信发送展位图、报价单及往届案例，提醒李经理查收，主动询问方案同步进度及疑问。李经理反馈报价单中特装搭建费用偏高，希望调整搭建规格以控制成本，同时询问是否可赠送 1 次展会手册彩页广告。",
          khfk: "内部初步同意参展，需确认调整后的搭建报价，若符合预算可本周内签订合同；要求了解展位搭建的周期及验收标准。",
          tps: [
            require("@/assets/images/login.png"),
            require("@/assets/images/login.png"),
          ],
          add_admin_name: "张三",
          add_department_name: "销售部",
          create_time: "2026-04-18 10:00:00",
        },
        {
          id: 2,
          rq: "2026-04-18",
          type_name: "上门拜访",
          gjnr: "微信发送展位图、报价单及往届案例，提醒李经理查收，主动询问方案同步进度及疑问。李经理反馈报价单中特装搭建费用偏高，希望调整搭建规格以控制成本，同时询问是否可赠送 1 次展会手册彩页广告。",
          khfk: "内部初步同意参展，需确认调整后的搭建报价，若符合预算可本周内签订合同；要求了解展位搭建的周期及验收标准。",
          tps: [
            require("@/assets/images/login.png"),
            require("@/assets/images/login.png"),
          ],
          add_admin_name: "张三",
          add_department_name: "销售部",
          create_time: "2026-04-18 10:00:00",
        },
        {
          id: 3,
          rq: "2026-04-18",
          type_name: "上门拜访",
          gjnr: "微信发送展位图、报价单及往届案例，提醒李经理查收，主动询问方案同步进度及疑问。李经理反馈报价单中特装搭建费用偏高，希望调整搭建规格以控制成本，同时询问是否可赠送 1 次展会手册彩页广告。",
          khfk: "内部初步同意参展，需确认调整后的搭建报价，若符合预算可本周内签订合同；要求了解展位搭建的周期及验收标准。",
          tps: [
            require("@/assets/images/login.png"),
            require("@/assets/images/login.png"),
          ],
          add_admin_name: "张三",
          add_department_name: "销售部",
          create_time: "2026-04-18 10:00:00",
        },
        {
          id: 4,
          rq: "2026-04-18",
          type_name: "上门拜访",
          gjnr: "微信发送展位图、报价单及往届案例，提醒李经理查收，主动询问方案同步进度及疑问。李经理反馈报价单中特装搭建费用偏高，希望调整搭建规格以控制成本，同时询问是否可赠送 1 次展会手册彩页广告。",
          khfk: "内部初步同意参展，需确认调整后的搭建报价，若符合预算可本周内签订合同；要求了解展位搭建的周期及验收标准。",
          tps: [
            require("@/assets/images/login.png"),
            require("@/assets/images/login.png"),
          ],
          add_admin_name: "张三",
          add_department_name: "销售部",
          create_time: "2026-04-18 10:00:00",
        },
        {
          id: 5,
          rq: "2026-04-18",
          type_name: "上门拜访",
          gjnr: "微信发送展位图、报价单及往届案例，提醒李经理查收，主动询问方案同步进度及疑问。李经理反馈报价单中特装搭建费用偏高，希望调整搭建规格以控制成本，同时询问是否可赠送 1 次展会手册彩页广告。",
          khfk: "内部初步同意参展，需确认调整后的搭建报价，若符合预算可本周内签订合同；要求了解展位搭建的周期及验收标准。",
          tps: [
            require("@/assets/images/login.png"),
            require("@/assets/images/login.png"),
          ],
          add_admin_name: "张三",
          add_department_name: "销售部",
          create_time: "2026-04-18 10:00:00",
        },
        {
          id: 6,
          rq: "2026-04-18",
          type_name: "上门拜访",
          gjnr: "微信发送展位图、报价单及往届案例，提醒李经理查收，主动询问方案同步进度及疑问。李经理反馈报价单中特装搭建费用偏高，希望调整搭建规格以控制成本，同时询问是否可赠送 1 次展会手册彩页广告。",
          khfk: "内部初步同意参展，需确认调整后的搭建报价，若符合预算可本周内签订合同；要求了解展位搭建的周期及验收标准。",
          tps: [
            require("@/assets/images/login.png"),
            require("@/assets/images/login.png"),
          ],
          add_admin_name: "张三",
          add_department_name: "销售部",
          create_time: "2026-04-18 10:00:00",
        },
      ];
      // delete state.bmData;

      // customercontact_page(state.params).then((res) => {
      //   if (res.status == 200) {
      //     const { list, count } = res.data?.data;
      //     state.list_data = list;
      //     state.totalCount = count;
      //   }
      // });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(() => {}, row.id, onLoad, {
        filed: "客户联系人",
        name: row.name,
      });
    };

    return { state, props, onLoad, onDelete };
  },
};
</script>

<style lang="scss" scoped></style>
